module.exports = __webpack_public_path__ + "static/img/ColorSection.97a8db98.webp";